import React, { useEffect, useState } from 'react';
import { Navbar, Footer } from '../components';
import { contactAPI } from '../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import './ContactPage.css';

const ContactPage = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [securityCheck, setSecurityCheck] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [num1, setNum1] = useState(5);
    const [num2, setNum2] = useState(14);

    useEffect(() => {
        window.scrollTo(0, 0);
        resetMathProblem();
    }, []);

    const resetMathProblem = () => {
        const randNum = Math.floor(Math.random() * 10) + 1;
        const total = randNum + Math.floor(Math.random() * 10) + 5;
        setNum1(randNum);
        setNum2(total);
        setSecurityCheck('');
    };

    const validateForm = () => {
        const newErrors = {};

        if (!firstName.trim()) newErrors.firstName = 'First name is required.';
        if (!lastName.trim()) newErrors.lastName = 'Last name is required.';
        
        if (!email.trim()) {
            newErrors.email = 'Email address is required.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }

        if (!subject.trim()) newErrors.subject = 'Subject is required.';
        if (!message.trim()) newErrors.message = 'Message is required.';
        if (!securityCheck.toString().trim()) newErrors.securityCheck = 'Security check is required.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        const expectedAnswer = num2 - num1;
        if (parseInt(securityCheck, 10) !== expectedAnswer) {
            setErrors({ securityCheck: 'Security check failed. Please try again.' });
            resetMathProblem();
            return;
        }

        setErrors({});
        setLoading(true);
        try {
            // The curl specifies: first_name, last_name, email, topic, message
            // We append phone to message or topic if needed, but we'll stick to topic for subject.
            let topicTopic = subject;
            if (!topicTopic && phone) topicTopic = `Phone: ${phone}`;
            if (!topicTopic) topicTopic = 'General Inquiry';

            await contactAPI.submitContactUs({
                first_name: firstName.trim(),
                last_name: lastName.trim(),
                email: email.trim(),
                topic: topicTopic.trim(),
                message: message.trim()
            });
            
            toast.success('Your message has been sent successfully!');
            // Reset form
            setFirstName('');
            setLastName('');
            setEmail('');
            setPhone('');
            setSubject('');
            setMessage('');
            setErrors({});
            resetMathProblem();
        } catch (error) {
            console.error('Contact Us submission error:', error);
            toast.error(error.message || 'Failed to send message. Please try again later.');
            resetMathProblem();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-page-artisanal">
            <Navbar />

            <div className="contact-artisanal-wrapper">
                <h1 className="outline-heading">
                    CONTACT US
                </h1>

                <div className="form-container">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row-2">
                            <div className="field-group">
                                <label>First Name <span>*</span></label>
                                <input 
                                    type="text" 
                                    placeholder="Enter first name" 
                                    value={firstName}
                                    onChange={(e) => { setFirstName(e.target.value); if(errors.firstName) setErrors({...errors, firstName: ''}); }}
                                    style={{ borderColor: errors.firstName ? '#dc3545' : '' }}
                                />
                                {errors.firstName && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.firstName}</span>}
                            </div>
                            <div className="field-group">
                                <label>Last Name <span>*</span></label>
                                <input 
                                    type="text" 
                                    placeholder="Enter last name" 
                                    value={lastName}
                                    onChange={(e) => { setLastName(e.target.value); if(errors.lastName) setErrors({...errors, lastName: ''}); }}
                                    style={{ borderColor: errors.lastName ? '#dc3545' : '' }}
                                />
                                {errors.lastName && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.lastName}</span>}
                            </div>
                        </div>

                        <div className="field-group">
                            <label>Email <span>*</span></label>
                            <input 
                                type="email" 
                                placeholder="Enter email address" 
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); if(errors.email) setErrors({...errors, email: ''}); }}
                                style={{ borderColor: errors.email ? '#dc3545' : '' }}
                            />
                            {errors.email && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.email}</span>}
                        </div>

                        {/* <div className="field-group">
                            <label>Phone</label>
                            <input 
                                type="tel" 
                                placeholder="Enter phone number" 
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div> */}

                        <div className="field-group">
                            <label>Subject <span>*</span></label>
                            <input 
                                type="text" 
                                placeholder="Enter subject" 
                                value={subject}
                                onChange={(e) => { setSubject(e.target.value); if(errors.subject) setErrors({...errors, subject: ''}); }}
                                style={{ borderColor: errors.subject ? '#dc3545' : '' }}
                            />
                            {errors.subject && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.subject}</span>}
                        </div>

                        <div className="field-group">
                            <label>Message <span>*</span></label>
                            <textarea 
                                placeholder="Tell us what's on your mind..."
                                value={message}
                                onChange={(e) => { setMessage(e.target.value); if(errors.message) setErrors({...errors, message: ''}); }}
                                style={{ borderColor: errors.message ? '#dc3545' : '' }}
                            ></textarea>
                            {errors.message && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.message}</span>}
                        </div>

                        <div className="field-group">
                            <label>Security Check (What + {num1} = {num2} ?) <span>*</span></label>
                            <div className="security-check">
                                <input 
                                    type="number" 
                                    value={securityCheck}
                                    onChange={(e) => { setSecurityCheck(e.target.value); if(errors.securityCheck) setErrors({...errors, securityCheck: ''}); }}
                                    placeholder="?"
                                    style={{ width: '80px', marginRight: '10px', borderColor: errors.securityCheck ? '#dc3545' : '' }}
                                />
                                <span className="math-prob">+ {num1} = {num2}</span>
                            </div>
                            {errors.securityCheck && <span style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px', display: 'block' }}>{errors.securityCheck}</span>}
                        </div>

                        <button 
                            type="submit" 
                            className="submit-button"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Sending...
                                </>
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ContactPage;
